import { useCallback, useRef } from 'react';
export function useScrollSync(refs, disabled) {
    if (disabled === void 0) { disabled = false; }
    var activeElement = useRef(null);
    var onScroll = useCallback(function (event) {
        var targetElement = event.target;
        if (targetElement && (activeElement.current === null || activeElement.current === targetElement)) {
            requestAnimationFrame(function () {
                activeElement.current = targetElement;
                refs.forEach(function (ref) {
                    var element = ref.current;
                    if (element && element !== targetElement) {
                        element.scrollLeft = targetElement.scrollLeft;
                    }
                });
                requestAnimationFrame(function () {
                    activeElement.current = null;
                });
            });
        }
    }, []);
    return !disabled ? onScroll : undefined;
}
